import React, { useState, useEffect } from 'react';
import { Form, Radio } from 'antd';
import SprayUnitForm from './SprayUnitForm';
import SprayNozzleForm from './SprayNozzleForm';

const SprayForm = (props) => {
  const [type, setType] = useState();

  useEffect(() => {
    if (!props.data) return;
    
    setType(props.data?.spray_type);
  }, [props.data]);

  const renderSprayType = () => (
    <Radio.Group
      options={[
        { value: 'spray_unit', label: 'Spray Unit' },
        { value: 'spray_nozzle', label: 'Spray Nozzle' },
      ]}
      value={type}
      onChange={(e) => setType(e.target.value)}
    />
  );

  return (
    <>
      <Form.Item
        name={['spray', 'spray_type']}
        className="isoInputWrapper"
        label="Select an asset type"
        rules={[{ required: true, message: 'This field is required' }]}
      >
        {renderSprayType()}
      </Form.Item>

      {type === 'spray_unit' && <SprayUnitForm />}
      {type === 'spray_nozzle' && <SprayNozzleForm />}
    </>
  );
};

export default SprayForm;